<ion-header>
  <ion-toolbar class="header-toolbar">
    <ion-text slot="start">Create</ion-text>
    <ion-buttons slot="end">
      <ion-button (click)="onDismiss()">
        <ion-icon slot="icon-only" name="close-outline" class="x" />
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ion-toolbar class="header-toolbar">
    <ion-segment
      *ngrxLet="{ segmentConfig: store.segmentConfig$ } as vm"
      mode="ios"
      [(ngModel)]="selectedFeature"
      slot="start"
      [scrollable]="true"
      (ionChange)="onSegmentChange()">
      @for (config of vm.segmentConfig; track config.feature) {
        @if (!config.hideSegment) {
          <ion-segment-button [value]="config.feature" class="feature-button">
            {{ config.displayText }}
          </ion-segment-button>
        }
      }
    </ion-segment>
  </ion-toolbar>
</ion-header>

<!-- WARNING: Do not place this ion-content & ng-container inside a wrapping container or template -->
<ion-content>
  <ng-container #content />

  <ion-footer>
    <ion-toolbar>
      <ion-button
        *ngrxLet="{
          linkedItem: store.linkedItem$,
          enable: store.enable$,
        } as vm"
        expand="block"
        shape="round"
        size="default"
        (click)="onSave(vm.linkedItem)"
        class="nty-universal-create-button">
        <nty-universal-create-button-text />
      </ion-button>
    </ion-toolbar>
  </ion-footer>
</ion-content>

<ng-container
  *ngrxLet="{
    loading: store.isCreating$,
    message: store.creationMessage$,
    processingAttachments: store.processingAttachments$,
  } as vm">
  @if (vm.loading || vm.processingAttachments) {
    <nty-loading />
  }
</ng-container>
